module.exports = __webpack_public_path__ + "static/media/pm_signup.96e2bc0c.svg";